import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _capitalize from "lodash/capitalize";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import { Container } from "../../Container/Container/Container";
import { MemberCarousel } from "../../MemberCarousel/MemberCarousel";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Background } from "../../Background/Background";
import { Text } from "../../Text/Text/Text";
import styles from "./MemberCarouselSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var memberCarouselAlign = ['left', 'center'];
export var memberCarouselEyebrowTypogs = ['eyebrow1', 'eyebrow2', 'eyebrow3', 'headline7'];
export var MemberCarouselSlice = function MemberCarouselSlice(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    background = _ref.background,
    _ref$eyebrow = _ref.eyebrow,
    eyebrow = _ref$eyebrow === void 0 ? {
      text: '',
      typog: 'headline7'
    } : _ref$eyebrow,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? {
      ariaLevel: 2,
      text: '',
      typog: 'headline3',
      variant: 'default'
    } : _ref$heading,
    members = _ref.members,
    _ref$footnote = _ref.footnote,
    footnote = _ref$footnote === void 0 ? '' : _ref$footnote;
  return /*#__PURE__*/_jsx(Background, _objectSpread(_objectSpread({}, background), {}, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.memberCarousel,
        children: [/*#__PURE__*/_jsxs("div", {
          className: align && (eyebrow && eyebrow.text || heading && heading.text) ? classnames(styles.header, styles["memberCarouselHeaderAlign".concat(_capitalize(align))]) : undefined,
          children: [(eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.text) && (eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.typog) && /*#__PURE__*/_jsx(Text, {
            className: styles.eyebrow,
            typog: eyebrow.typog,
            children: eyebrow.text
          }), (heading === null || heading === void 0 ? void 0 : heading.text) && (heading === null || heading === void 0 ? void 0 : heading.ariaLevel) && (heading === null || heading === void 0 ? void 0 : heading.typog) && (heading === null || heading === void 0 ? void 0 : heading.variant) && align && /*#__PURE__*/_jsx(HeadingText, {
            align: align,
            ariaLevel: heading.ariaLevel,
            typog: heading.typog,
            variant: heading.variant,
            children: heading.text
          }, "heading")]
        }), members && /*#__PURE__*/_jsx("div", {
          className: styles.carouselWrapper,
          children: /*#__PURE__*/_jsx(MemberCarousel, {
            members: members
          })
        }), footnote && /*#__PURE__*/_jsx(Text, {
          typog: "captionSmall",
          className: styles.footnote,
          richText: true,
          children: footnote
        })]
      })
    })
  }));
};